(() => {
	const downloadButtons = [...document.querySelectorAll(".js-download-button")];

	const origin = window.location.origin;
	const target = "https://jeremiahoei.firstfruitsstudio.workers.dev/book";

	const recaptchaSiteKey = "6LfO_s0aAAAAAPQ7OlUOppQeLRW4XVMvOydsEznf";
	
	for (const button of downloadButtons) {
		button.addEventListener("click", (ev) => {
			ev.preventDefault();

			const ebookCode = button.dataset.ebookCode;
			const ebookLanguage = button.dataset.ebookLanguage;
			const ebookFormat = button.dataset.ebookFormat;

			grecaptcha.ready(() => {
				grecaptcha.execute(recaptchaSiteKey, { action: "submit" }).then(recaptchaToken => {
					const postData = {
						origin,
						code: ebookCode,
						language: ebookLanguage,
						format: ebookFormat,
						recaptchaToken,
					};
					
					fetch(target, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(postData),
					}).then(r => r.json())
					.then(obj => {
						const url = obj.url;
						window.location.href = url;
					})
					.catch(e => console.error(e));
				});
			});
		});
	}
})();